<script setup>
defineProps({
  visible: { type: Boolean, default: false },
  x: { type: Number, default: 0 },
  y: { type: Number, default: 0 },
  title: { type: String, default: "" },
  // rows: [{ label, value, color }]
  rows: { type: Array, default: () => [] },
});
</script>

<template>
  <div v-if="visible" class="an-tooltip" :style="{ left: x + 'px', top: y + 'px' }">
    <div v-if="title" class="an-tooltip__title">{{ title }}</div>
    <div v-for="(row, i) in rows" :key="i" class="an-tooltip__row">
      <span v-if="row.color" class="an-tooltip__swatch" :style="{ background: row.color }"></span>
      <span class="an-tooltip__label">{{ row.label }}</span>
      <span class="an-tooltip__value">{{ row.value }}</span>
    </div>
  </div>
</template>

<style scoped>
.an-tooltip {
  position: fixed;
  z-index: 1200;
  pointer-events: none;
  transform: translate(14px, 14px);
  min-width: 140px;
  padding: 8px 10px;
  background: var(--an-panel);
  border: 1px solid var(--an-line);
  border-radius: 8px;
  box-shadow: 0 8px 20px -6px rgba(0, 0, 0, 0.4);
  font-size: 12px;
  color: var(--an-text);
}

.an-tooltip__title {
  font-weight: 600;
  font-size: 11.5px;
  color: var(--an-muted);
  margin-bottom: 4px;
}

.an-tooltip__row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  white-space: nowrap;
}

.an-tooltip__swatch {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex-shrink: 0;
}

.an-tooltip__label {
  flex: 1;
  color: var(--an-muted);
}

.an-tooltip__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--an-text);
}
</style>
